import React from "react";
import "../../../../Assets/Css/Project.scss";
import Table from "../../../../Components/Table";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { getprojects } from "../../../../Services/Project/action";
import { exportData } from "../../../../Lib/exportData";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";


const EmpProjectMember = (props) => {
    const [inData, setInData] = useState([]);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const { projectId } = useParams();
    useEffect(() => {
        const fetchData = async () => {
            await props?.getprojects();
        }

        fetchData();
    }, []);
    const header = [
        { field: 'checkbox' },
        { field: "ID" },
        { field: "Name" },
        { field: "User Role" },
    ];

    let footer = true;
    let count = inData?.length;


    useEffect(() => {
        const selectedProject = props?.project?.find(
            (item) => String(item?.id) == String(projectId)
        );

        setInData(selectedProject?.projectUserMap?.filter(item => item?.userProjectMap)?.map((userObj) => {
            const user = userObj?.userProjectMap;
            return {
                checkbox: {
                    value: userObj?.id,
                    type: 'checkbox',
                },
                ID: {
                    value: userObj?.id,
                    type: "text",
                },
                "Name": {
                    image: user?.profile_pic ? `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.profile_pic?.data)))}` : '',
                    value: user?.name,
                    value2: user?.designation?.name,
                    type: !user?.profile_pic ? 'client' : "image_round",
                },
                "User Role": {
                    value: user?.designation?.name,
                    type: "text",
                },
                allData: {
                    ...userObj
                },
            }
        }));
    }, [props?.project]);

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));
        try {
            setExportLoading(true);
            handleXlsxDownload(ids);
            toast.success("Exported Successfully");
        } catch (error) {
            console.error(error);
        }
    };

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = inData
            .filter(item => Ids.includes(item.allData?.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });

        exportData({
            data: selectedData,
            columns,
            fileName: 'Project_Member_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };

    return (
        <div className="project-main">
            <div className="gap-4 emptask-export-btn">
                <button
                    className="export-btn"
                    id="exportBtn"
                    disabled={totalSelectedIds.length <= 0 || exportLoading}
                    onClick={(e) => {
                        e.preventDefault();
                        handleClick(totalSelectedIds, 'export');
                    }}
                >
                    {exportLoading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        'Export'
                    )}
                </button>
            </div>
            <div className="invoice-table-part">
                <Table
                    header={header}
                    data={inData}
                    footer={footer}
                    count={count}
                    records={count}
                    loading={props.loading}
                    totalSelectedIds={totalSelectedIds}
                    handleChange={handleChange}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.taskReducer.loading,
        project: state.projectReducer.project,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getprojects: () => {
            dispatch(getprojects());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectMember);

